import type { ReleaseChannel } from '@hoedokloop/observability';

export const productChannel: ReleaseChannel =
  import.meta.env['VITE_HOEDOKLOOP_CHANNEL'] === 'ait' ? 'ait' : 'web';
